import { Ploc, ServicesApiResponse } from '@hfc/ui-core';
import { FindFeaturedPostUseCase } from '@/blog/application/FindFeaturedPostUseCase';
import { Post } from '@/blog/domain/Post';
import { PostMemory } from '@/blog/infrastructure/dataSource/PostMemory';
import { PostFilters } from '@/blog/infrastructure/types/PostFilters';
import { BlogPage } from '@/blog/domain/BlogPage';
import { GetBlogPageUseCase } from '@/blog/application/GetBlogPageUseCase';
import { PostApi } from '@/blog/infrastructure/dataSource/PostApi';

const memoryRepository = new PostMemory();
const repository = new PostApi();
const findFeatured = new FindFeaturedPostUseCase(memoryRepository);
const getBlogPage = new GetBlogPageUseCase(repository);

export interface PostStoreInterface {
  featured: Post
  featuredLoaded: boolean

  allPosts: Array<Post>
  allPostLoading: boolean
  blogPage: BlogPage
  blogPageLoading: boolean

}

const initialState: PostStoreInterface = {
  featured: {} as Post,
  featuredLoaded: false,

  allPosts: [],
  allPostLoading: true,

  blogPage: {} as BlogPage,
  blogPageLoading: true,

};

export class PostStore extends Ploc<PostStoreInterface> {

  public constructor () {
    super(initialState);
  }

  public changeLoadedState (): void {
    this.changeState({ ...this.state, featuredLoaded: !this.state.featuredLoaded });
  }

  public async getFeaturedPost (): Promise<void> {
    this.changeState({ ...this.state, featuredLoaded: false });
    const featured = await findFeatured.run();
    this.changeState({ ...this.state, featured: featured });
    this.changeState({ ...this.state, featuredLoaded: true });
  }

  public async getBlogPage (filters: PostFilters): Promise<ServicesApiResponse<BlogPage>> {
    this.changeState({ ...this.state, blogPageLoading: true, allPostLoading: true });
    const response = await getBlogPage.run(filters);
    if (response.success && response.data) {
      this.changeState({ ...this.state, blogPage: response.data, blogPageLoading: false, allPostLoading: false, allPosts: response.data.posts });

      return response;
    }
    this.changeState({ ...this.state, blogPageLoading: false, allPostLoading: false });

    return response;
  }

  public async getPosts (filters: PostFilters): Promise<ServicesApiResponse<BlogPage>> {
    this.changeState({ ...this.state, allPostLoading: true });
    const response = await getBlogPage.run(filters);
    if (response.success && response.data) {
      this.changeState({ ...this.state, allPosts: response.data.posts, allPostLoading: false, blogPage: response.data });

      return response;
    }
    this.changeState({ ...this.state, allPostLoading: false });

    return response;
  }

}
